<template>
  <div 
    class="  px-10 mt-12">
    <v-layout wrap>
      <v-flex>
        <section>
          
          <div class="color-dark-blue fs-22 font-weight-bold">
            Detail Penerimaan
          </div>

          <v-row
            class="">
            <v-col 
              cols="12"
              class="px-0">
              <v-card 
                flat
                min-height="calc(100vh - 245px)"
                style="border-radius: 25px; border: 1px solid #E7E7E7;">
                <v-card-text
                    v-if="process.form" 
                    class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-2 title">
                        Mohon Tunggu...
                      </div>
                      <v-progress-circular
                        indeterminate
                      ></v-progress-circular>
                    </div>
                  </v-card-text>

                  <v-card-text v-if="!process.form">
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <!-- <div
                        class="mb-4">
                        <div 
                          class="body-2 mb-2">
                          Poto Profil
                        </div>

                        <uploadfolder v-if="form.image_url === ''"
                          v-model="upload.image">
                          <div 
                            slot="activator">
                            <v-card 
                              flat
                              width="200"
                              height="200"
                              class="d-flex align-center justify-center cursor-pointer"
                              style="border-radius: 15px;
                                    border: 2px solid #EBEBEB; 
                                    border-style: dashed;">
                              <v-avatar v-if="!process.image"
                                v-ripple
                                tile 
                                width="200"
                                height="200">
                                <v-icon
                                  size="50"
                                  color="#B9B9B9">
                                  mdi-cloud-upload-outline
                                </v-icon>
                              </v-avatar>

                              <v-progress-circular v-else
                                indeterminate
                                :color="set_color">
                              </v-progress-circular>
                            </v-card>
                          </div>
                        </uploadfolder>

                        <v-card v-if="form.image_url !== ''"
                          flat
                          width="200"
                          height="200"
                          class="d-flex align-center justify-center"
                          style="border-radius: 15px;
                                border: 2px solid #EBEBEB; 
                                border-style: dashed;">
                          <v-avatar
                            v-ripple
                            tile 
                            size="200"
                            style="border-radius: 15px;">
                            <v-img 
                              contain
                              width="100%"
                              height="100%"
                              alt="Mitra Warung" 
                              :src="form.image_url"
                              class="ma-auto"
                              style="border-radius: 15px;">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>

                          <v-icon 
                            @click="form.image_url = ''"
                            color="red"
                            class="cursor-pointer"
                            style="position: absolute; top: -10px; right: -10px;">
                            mdi-close-circle
                          </v-icon>
                        </v-card>
                      </div> -->

                      <v-row>

                        <v-col cols="3">
                          <div 
                            class="fs-15 label-input">
                            Pembelian
                          </div>
    
                          <div class="fs-17 font-weight-bold label-input">
                            {{ form.po_number }}
                          </div>
                        </v-col>
                        <v-col cols="3">
                          
                          <div 
                            class="fs-15 label-input">
                            <!-- <span class="red--text">*</span> -->
                            Nomor Penerimaan
                          </div>
    
                          <div class="fs-17 font-weight-bold label-input">
                            {{ form.number }}
                          </div>
                        </v-col>
                        <v-col cols="3">
                          
                          <div 
                            class="fs-15 label-input">
                            <!-- <span class="red--text">*</span> -->
                            Nomor Surat Jalan
                          </div>
    
                          <div class="fs-17 font-weight-bold label-input">
                            {{ form.no_surat_jalan }}
                          </div>
                        </v-col>
                        <v-col cols="3">
                          
                          <div class="fs-15 label-input">
                          <!-- <span class="red--text">*</span> -->
                          
                            Tanggal Input
                          </div>
            
                          <div class="fs-17 font-weight-bold label-input">
                            {{ form.date | date }}
                          </div>
                        </v-col>
                        
                        <v-col
                          cols="12"
                          md="11" class="pt-0 pr-8">
                          <div>
                            <div class="mt-5">
                              Data Varian
                            </div>
                            <v-divider class="my-3"></v-divider>
                            <div v-for="(item, index) in form.varian_arr" :key="index">
                              <v-card flat class="mb-5" style="border-radius: 25px; border: 1px solid #E7E7E7;">
                                <v-card-text class="">
                                  <div class="d-flex">
                                    <div>
                                      <div class="fs-16 font-weight-bold label-input">
                                        {{ item.name }}
                                      </div>
                                      <div>
                                        <span>Kode SKU</span>: <span>{{ item.sku }}</span>
                                      </div>
                                      <div>
                                        <span>Unit</span>: <span>{{ item.unit }}</span>
                                      </div>
                                      <div>
                                        <span>Qty</span>: <span>{{ item.qty }}</span>
                                      </div>
                                      <!-- <div>
                                        <span>Harga Beli</span>: <span>{{ item.harga_beli | price }}</span>
                                      </div>
                                      <div>
                                        <span>PPN</span>: <span>{{ item.ppn_beli }}</span>
                                      </div> -->
                                      <div>
                                        <span>Tanggal Expired</span>: <span>{{ item.expired_date | date }}</span>
                                      </div>
                                    </div>
                                    
                                  </div>

                                  <v-row>

                                    <v-col cols="2">
                                      <div class="fs-15 label-input">
                                        <!-- <span class="red--text">*</span> -->
                                        Qty Extra
                                      </div>

                                      <div class="fs-18 label-input font-weight-bold">
                                        {{ item.qty_extra }}
                                      </div>
              
                                    </v-col>

                                    <v-col>
                                      <ValidationProvider
                                        :name="`Qty QC ${item.name}`" 
                                        rules="min_value:0" 
                                        v-slot="{ errors }">
                                        <div 
                                          class="fs-15 label-input">
                                          Qty QC
                                        </div>
                  
                                        <v-currency-field
                                        
                                          filled
                                          rounded
                                          dense
                                          solo
                    
                                          color="#718EBF"
                                          placeholder="Qty QC"

                                          
                    
                                          v-model="item.qty_qc"
                                          :error-messages="errors"
                                          
                                          style="border-radius: 10px;">
                                        </v-currency-field>
                                      </ValidationProvider>
              
                                    </v-col>
                                  </v-row>

                                </v-card-text>
                              </v-card>
                            </div>
                          </div>
                        </v-col>

                        <!-- <v-col cols="5">
                          <div class="fs-15 label-input">
                            Bukti
                          </div>

                          <div v-if="bukti === 'gambar'">

                                <v-card 
                                  flat
                                  width="350"
                                  height="350"
                                  class="d-flex align-center justify-center"
                                  style="border-radius: 15px;
                                        border: 2px solid #eaeaea; 
                                        border-style: dashed;">
  
                                  <v-img 
                                    contain
                                    height="350"
                                    :src="gambar_url" 
                                    :alt="gambar_url"
                                    class="text-center d-flex align-center">
                                    <div 
                                      class="d-flex aling-center justify-center" 
                                      style="width: 100%; height: auto;">
                                      
  
                                    </div>
                                  </v-img>
                                </v-card>
                          </div>

                          <div v-if="bukti === 'pdf'">

                                <v-card 
                                  flat
                                  height="350"
                                  width="350"
                                  class="d-flex align-center justify-center"
                                  style="border-radius: 15px;
                                        border: 2px solid #eaeaea; 
                                        border-style: dashed;">
                                  

                                  <div>
                                    <iframe :src="pdf_url" height="350" frameborder="0"></iframe>
                                  </div>
  
                                </v-card>
                          </div>

                          
                        </v-col> -->
                        
                      </v-row>

                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pt-0 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn 
                @click="save()"
                :loading="process.form || process.load"
                :disabled="process.form || process.load"
                width="190"
                height="45"
                elevation="0"
                color="#1814F3"
                class="fs-16 white--text text-capitalize border-radius">
                Simpan
              </v-btn>

              <v-btn
                @click="$router.go(-1)"
                :disabled="process.form || process.load"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Kembali
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: {
          
        },
        modal: false,
        menu2: false,

        dialog: {
          customer: false,
          fullscreen: false
        },
        bukti: 'gambar',
        gambar_url: '',
        pdf_url: '',
        category: ['Gambar', 'Pdf'],
        pembelian: [],
        product_id: '',
        selected: [],
        headers: [],
        list: [],
        supplier: [],
        form: {
          id: '',
          po_id: '',
          number: '',
          no_surat_jalan: '',
          date: '',
          bukti_url: '',
          varian_arr: [],
          po_number: ''
        },
        headers_data: [],
        supervisor: [],
        branch: [],

        mobilephone: {
          name: '',
          id: ''
        },

        lastIndex: 1,

        upload: {
          pdf_url: null,
          image_url: null
        },

        process: {
          form: true,
          load: true,

          pdf_url: false,

          image_url: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
      uploaddocument: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/document.vue')
    },
    watch: {
      'upload.pdf_url': {
        handler: function () {
          if (this.upload.pdf_url) {
            this.process.pdf_url = this.upload.pdf_url.process

            if (!this.process.pdf_url) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.pdf_url = this.upload.pdf_url.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      },

      'upload.image_url': {
        handler: function () {
          if (this.upload.image_url) {
            this.process.image_url = this.upload.image_url.process

            if (!this.process.image_url) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.gambar_url = this.upload.image_url.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      configHeaders () {
          return this.headers_data.filter(header => !header.hide)  
        },
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.form = true
        let params = {
          id: this.$route.params.id
        }

        await get('admin/penerimaan/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.form.id = res.results.data.id
            this.form.po_id = res.results.data.po_id
            this.form.number = res.results.data.number
            this.form.no_surat_jalan = res.results.data.no_surat_jalan
            this.form.date = res.results.data.date
            this.form.bukti_url = res.results.data.bukti_url
            this.form.po_number = res.results.data.po_number
            this.form.varian_arr = res.results.data.detail.map(item => {
              return {
                detail_id: item.penerimaan_detail_id,
                id: item.penerimaan_detail_varian_id,
                sku: item.penerimaan_detail_varian_sku,
                name: item.penerimaan_detail_varian_name,
                unit: item.penerimaan_detail_varian_unit,
                qty: item.penerimaan_detail_qty,
                harga_beli: item.penerimaan_detail_harga_beli,
                ppn_beli: item.penerimaan_detail_ppn_beli,
                expired_date: item.penerimaan_detail_expired_date,
                qty_extra: item.penerimaan_detail_qty_extra,
                qty_qc: 0
              }
            })
            // this.menu = res.results.data.detail.map(item => {
            //   return {
            //     menu: false
            //   }
            // })
            
          }
          // this.fetchSales()
          this.process.form = false

          this.fetchPembelian()
        })
      },
      async fetchPembelian () {
        this.process.load = true

        let params = {
          limit: 1000000,
          status: 'terbit'
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/pembelian/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.pembelian = res.results.data
            
          }
          this.process.load = false
        })
      },
      changePembelian() {
        this.fetchDetailPembelian()
      },
      async fetchDetailPembelian () {
        let params = {
          id: this.form.po_id
        }

        await get('admin/pembelian/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.form.varian_arr = res.results.data.detail.map(item => {
              return {
                id: item.po_detail_varian_id,
                sku: item.po_detail_varian_sku,
                name: item.po_detail_varian_name,
                unit: item.po_detail_varian_unit,
                qty: item.po_detail_qty,
                harga_beli: item.po_detail_harga_beli,
                ppn_beli: item.po_detail_ppn_beli,
                expired_date: ''
              }
            })
            this.menu = res.results.data.detail.map(item => {
              return {
                menu: false
              }
            })
          }
          this.process.load = false
        })
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          let form = {
            id: this.form.id,
            varian_arr: JSON.stringify(this.form.varian_arr.map(item => {
              return {
                detail_id: item.detail_id,
                qty_qc: item.qty_qc
              }
            })),
          }
          this.process.load = true

          // SAVE TO REST API
          await post(`admin/penerimaan/qc`, {
            data: form
          })
          .then((response) => {
            let res = response.data

            this.process.load = false

            if (res.status === 200) {

              this.$router.push({ path: '/pengajuan/penerimaan/data' })

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>